import { defineStore } from 'pinia'

export interface NetworkState {
  network_status: any
}

export const useNetworkStore = defineStore('network', {
  state: (): NetworkState => ({
    network_status: null,
  }),

  getters: {
    getNetworkStatus: (state) => state.network_status,
  },

  actions: {
    resetNetworkStatus() {
      this.network_status = null
    },

    setNetworkStatus(status: any) {
      this.network_status = status
    },
  },
})
